// defines custom impress cursor
const cursor = document.querySelector('#impress-cursor')
const Header = document.querySelector('#header')
const Footer = document.querySelector('#footer')


document.addEventListener('mousemove', (e) => {
    cursor.style.left = e.clientX + 'px'
    cursor.style.top = e.clientY + 'px'
})

Header.addEventListener("mouseenter", (e) => {
    cursor.classList.add('mix-blend')
})
Header.addEventListener("mouseleave", (e) => {
    cursor.classList.remove('mix-blend')
})

Footer.addEventListener("mouseenter", (e) => {
    cursor.classList.add('mix-blend')
})
Footer.addEventListener("mouseleave", (e) => {
    cursor.classList.remove('mix-blend')
})